import { render, staticRenderFns } from "./wirteoffcodesing.vue?vue&type=template&id=5724ccdc&scoped=true&"
import script from "./wirteoffcodesing.vue?vue&type=script&lang=js&"
export * from "./wirteoffcodesing.vue?vue&type=script&lang=js&"
import style0 from "./wirteoffcodesing.vue?vue&type=style&index=0&id=5724ccdc&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5724ccdc",
  null
  
)

export default component.exports